import { render, staticRenderFns } from "./ActivityGoodsList.vue?vue&type=template&id=c4622d82&scoped=true&"
import script from "./ActivityGoodsList.vue?vue&type=script&lang=js&"
export * from "./ActivityGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./ActivityGoodsList.vue?vue&type=style&index=0&id=c4622d82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4622d82",
  null
  
)

export default component.exports